@if (notifications$ | async; as current) {
    @let accaBoost = current.accaBoost;
    @let multiReturn = current.multiReturn;

    @if (current.tokensReminder && showRemindMe && isRemindMeLaterEnabled && !isRewardDrawerEnabled) {
        <bs-remind-me-later-notification
            class="tokens-reminder-notification"
            (closeTokensReminder)="resetReminder()"
            (undoTokensReminder)="resetReminder()" />
    }

    @if (!columnLayout.layout.isRightVisible && multiReturn && !isQuickBetOpen() && !isBetslipBarEnabled()) {
        <bs-digital-multi-returns-message-popup
            class="multi-returns-message"
            [message]="multiReturn"
            [isShowAccaUpdatedInfo]="!!accaBoost && isNotificationType(accaBoost, 'Ladder') && accaBoost.tokenSwitched"
            [animationState]="getMultiReturnAnimation(current)" />
    }

    @if (accaBoost) {
        @if (isNotificationType(accaBoost, 'Ladder')) {
            <bs-acca-boost-notification
                @accaBoostNotificationAnimation
                class="acca-boost-notification--ladder"
                *bsAccaRerenderer="accaBoost.token"
                [ngClass]="{ 'acca-boost-notification-ladder-us': usLadderEnabled }"
                [notification]="accaBoost"
                [icon]="'theme-info'"
                [usLadderEnabled]="usLadderEnabled"
                [@.disabled]="isBetslipBarEnabled()"
                (@accaBoostNotificationAnimation.done)="onAnimationDone($event, notificationTypeEnum.Ladder)">
                <bs-acca-boost-ladder [usLadderEnabled]="usLadderEnabled" [notification]="accaBoost" />
            </bs-acca-boost-notification>
        } @else if (isNotificationType(accaBoost, 'Error')) {
            <bs-acca-boost-notification
                @accaBoostNotificationAnimation
                class="acca-boost-notification--error"
                [class.acca-boost-notification-us]="usLadderEnabled"
                [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
                [showAccaBoostIcon]="!usLadderEnabled"
                [showInfoIcon]="usLadderEnabled"
                [notification]="accaBoost"
                [usLadderEnabled]="usLadderEnabled">
                <bs-acca-boost-error
                    [ngClass]="{ 'acca-boost-error-us': usLadderEnabled }"
                    [token]="accaBoost.token"
                    [error]="accaBoost.error"
                    [isTrendingAccas]="accaBoost.isTrendingAccasSelected" />
            </bs-acca-boost-notification>
        } @else if (isNotificationType(accaBoost, 'OneSelectionAway')) {
            <bs-acca-boost-notification
                @accaBoostNotificationAnimation
                class="acca-boost-notification--teaser"
                [notification]="accaBoost"
                [class.acca-boost-notification-us]="usLadderEnabled"
                [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
                [showInfoIcon]="usLadderEnabled"
                [showAccaBoostIcon]="!usLadderEnabled"
                [usLadderEnabled]="usLadderEnabled">
                <bs-acca-boost-teaser [ngClass]="{ 'acca-boost-teaser-us': usLadderEnabled }" [token]="accaBoost.token" />
            </bs-acca-boost-notification>
        } @else if (isNotificationType(accaBoost, 'MaxReward')) {
            <bs-acca-boost-notification
                @accaBoostNotificationAnimation
                class="acca-boost-notification--ladder acca-boost-notification--max-reward"
                [usLadderEnabled]="usLadderEnabled">
                <bs-acca-boost-ladder [usLadderEnabled]="usLadderEnabled" [notification]="accaBoost" />
            </bs-acca-boost-notification>
        }
    }
}

@if (isMobile && (betBuilderNotification$ | async); as betBuilderNotification) {
    <bs-bet-builder-popup [notificationMessage]="betBuilderNotification" />
}
